export default __webpack_public_path__ + "static/hw_ds18b20-48d097b739970f99f86b36094c0f004c.jpg";